module.exports = __webpack_public_path__ + "img/NG.66e20a66.png";